import { DataBean } from "../DataBean";

export class ResourceCost extends DataBean {


    public async getResourceCostCatalog(idCostingCenter:any,idIndirectCostType:any,regexStr:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getResourceCostCatalog_Number_Number_String", [idCostingCenter,idIndirectCostType,regexStr]);
    }

    public async getResourceCostCatalogvdos(idResourceCost:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getResourceCostCatalog_Number", [idResourceCost]);
    }

}